import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { Mail } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Canada Wordmark */}
          <div className="mb-6 md:mb-0">
            <img 
              src="/images/canada-wordmark.png" 
              alt="Government of Canada / Gouvernement du Canada" 
              className="h-10 w-auto"
            />
          </div>
          
          {/* Contact Info */}
          <div className="text-center md:text-right">
            <p className="text-gray-300 mb-2">{t.footerText}</p>
            <div className="flex items-center justify-center md:justify-end space-x-2">
              <Mail className="w-4 h-4" />
              <span className="text-sm">{t.getInTouch}</span>
              <a 
                href="mailto:MB.RCMP.CAPTURE@rcmp-grc.gc.ca" 
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                {t.email}
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} {language === 'en' ? 'Royal Canadian Mounted Police' : 'Gendarmerie royale du Canada'}. {language === 'en' ? 'All rights reserved.' : 'Tous droits réservés.'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
